<template>
    <section class="surname-research-section">
        <div>
            <h3 class="surname-title">Surname Research</h3>
        </div>

        <div class="row align-items-center">
            <div class="col-12 col-lg-6 mb-3 mb-lg-0">
                <div class="sidebar-search-widget mb-4">
                    <form v-on:submit.prevent @submit="search">
                        <input
                            class="form-control search-input"
                            type="search"
                            placeholder="Search Surname"
                            v-model="options.s"
                        >
                        <button type="button" @click="search"><i class="fa fa-search"></i></button>
                    </form>
                </div>
            </div>
            <div class="col-12 col-lg-6 d-flex justify-content-lg-end">
                <div class="d-flex align-items-center">
                    <span v-if="count">
                        {{ count }}
                        Item<span v-if="count > 1">s</span> Found
                    </span>
                    <span v-else>Nothing Found</span>
                </div>
            </div>
        </div>

        <div v-if="surnames.length" class="surname-table-wrap">
            <table class="surname-table">
                <thead>
                <tr>
                    <th class="action"></th>
                    <th class="surname">Surname</th>
                    <th v-for="field in surnameFields" :key="field.key" :class="field.className">{{ field.title }}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in surnames" :key="item.id">
                    <td>
                        <img v-if="isAuth" src="/images/envelope.png" alt="Envelope" title="Send mail" class="action-icon" @click="write(item.id)">
                        <img v-else src="/images/envelope-no-active.png" alt="Envelope" title="You must log in" class="action-icon no-active">
                    </td>
                    <td>{{ item.surname }}</td>
                    <td v-for="field in surnameFields" :key="field.key" :class="field.className">{{ item[field.key] }}</td>
                </tr>
                </tbody>
            </table>
        </div>
        <div v-if="surnames.length" class="row">
            <div class="col-12 d-flex justify-content-center mt-4">
                <pagination
                    v-model="options.page"
                    :records="count"
                    :per-page="options.itemsPerPage"
                    @paginate="loadData"
                    :options="{
                        chunksNavigation: 'scroll',
                        edgeNavigation: true
                    }"
                />
            </div>
        </div>

        <div id="popup" class="popup"  :style="'display: ' + (dialog.show ? 'block' : 'none')">
            <div class="popup-content" :style="'max-width: ' + dialog.width + ';'">
                <h5 class="modal-title mb-4">Surname Inquiry Emailer</h5>
                <div class="close" id="closePopup" @click="close">&times;</div>

                <template v-if="!isSent">
                    <div class="body">
                        <div style="margin-bottom: 8px;">
                            <label style="display: block;">Sender name</label>
                            <input type="text" v-model="form.name" style="width: 100%;">
                            <div class="error-messages">{{ messageFieldError('name') }}</div>
                        </div>

                        <div style="margin-bottom: 8px;">
                            <label style="display: block;">Sender email</label>
                            <input type="email" v-model="form.email" style="width: 100%;">
                            <div class="error-messages">{{ messageFieldError('email') }}</div>
                        </div>

                        <div style="margin-bottom: 8px;">
                            <label style="display: block;">Subject</label>
                            <input type="email" v-model="form.subject" style="width: 100%;">
                            <div class="error-messages">{{ messageFieldError('subject') }}</div>
                        </div>

                        <div>
                            <EditorComponent :value.sync="form.body" :toolbar="toolbar" />
                            <div class="error-messages">{{ messageFieldError('body') }}</div>
                        </div>
                    </div>

                    <div class="footer">
                        <button class="send" :disabled="isLoading" @click="sendMail">Send</button>
                    </div>
                </template>

                <template v-else>
                    <div style="padding: 16px 0;">
                        <div style="font-weight: bold; text-align: center; color: green;">Email sent successfully</div>
                    </div>
                </template>
            </div>
        </div>
    </section>
</template>

<script>
import EditorComponent from "./EditorComponent.vue";
import notifications from "../mixins/notifications";
import publicSettings from "../mixins/publicSettings";
import Pagination from 'vue-pagination-2';

export default {
    name: "SurnameResearchComponent",
    mixins: [
        notifications,
        publicSettings,
    ],
    components: {
        EditorComponent,
        Pagination,
    },
    data() {
        return {
            publicSettingsGroups: ['users'],
            isLoading: false,
            isSent: false,
            dialog: {
                show: false,
                width: '650px'
            },
            surnames: [],
            count: 0,
            form: {
                id: 0,
                subject: '',
                name: '',
                email: '',
                body: ''
            },
            toolbar: {
                items: [
                    'undo', 'redo',
                    '|', 'heading',
                    '|', 'bold', 'italic', 'strikethrough', 'subscript', 'superscript',
                    '|', 'alignment',
                    '|', 'bulletedList', 'numberedList', 'todoList', 'outdent', 'indent'
                ],
                shouldNotGroupWhenFull: true
            },
            options: {
                page: 1,
                itemsPerPage: 30,
                s: '', // search
            },
        }
    },
    computed: {
        surnameFields() {
            const config = this.getPublicSetting('surname_config') || {};
            const classNames = {
                udf1: 'country',
                udf2: 'state',
                udf3: 'county',
                udf4: 'city',
                udf5: 'udf',
                udf6: 'udf',
                udf7: 'udf',
                begin_year: 'begin-year',
                end_year: 'end-year',
                alt_spelling: 'alt-spelling',
                notes: 'notes',
            };

            return Object.entries(config)
                .filter(([, title]) => title && title.trim())
                .map(([key, title]) => ({
                    key,
                    title,
                    className: classNames[key] || 'udf',
                }));
        },
        isAuth() {
            return window.safeData.isAuth && window.safeData.isAuth === '1';
        }
    },
    watch: {
        'dialog.show': function (value) {
            if (value) {
                document.body.classList.add("modal-open");
            } else {
                document.body.classList.remove("modal-open");
            }
        }
    },
    mounted() {
        this.loadOptionsFromUrl();
        this.loadData();
    },
    methods: {
        updateUrl() {
            const queryParams = new URLSearchParams();

            queryParams.set('page', this.options.page);
            queryParams.set('itemsPerPage', this.options.itemsPerPage);

            if (this.options.s) {
                queryParams.set('s', this.options.s);
            }

            window.history.pushState({}, '', `${window.location.pathname}?${queryParams.toString()}`);
        },
        loadOptionsFromUrl() {
            const queryParams = new URLSearchParams(window.location.search);

            this.options.page = parseInt(queryParams.get('page')) || this.options.page;
            this.options.itemsPerPage = parseInt(queryParams.get('itemsPerPage')) || this.options.itemsPerPage;
            this.options.s = queryParams.get('s') || this.options.s;
        },
        initSubject(id) {
            const surname = this.surnames.find(item => item.id === id)?.surname ?? '';

            this.form.subject = 'Surname information request or available for ' + surname.toUpperCase();
        },
        loadData() {
            this.isLoading = true;

            this.$api.get('api/v1/surnames', {params: this.options}).then(response => {
                if (response.data) {
                    this.count = response.data.meta.total;
                    this.page = response.data.meta?.current_page;
                    this.surnames = response.data.data;

                    this.updateUrl();
                }
            }).finally(() => {
                this.isLoading = false;
            });
        },
        loadAuth() {
            this.isLoading = true;

            this.$api.get('api/v1/auth').then(response => {
                if (response.data) {
                    this.form.email = response.data.user.email;
                }
            }).finally(() => {
                this.isLoading = false;
            });
        },
        write(id) {
            this.initSubject(id);
            this.loadAuth();

            this.dialog.show = true;
            this.form.id = id;
        },
        sendMail() {
            this.isLoading = true;

            this.$api.post('api/v1/surnames', this.form).then(response => {
                if (response.data && response.data.status) {
                    this.clearValidateErrors();

                    if (response.data.status === 'success') {
                        this.dialog.width = '300px';
                        this.isSent = true;
                    }

                    if (response.data.status === 'error') {
                        this.setValidateErrors({
                            body: [response.data.message]
                        });
                    }
                }
            }).catch((error) => {
                if (error.response && error.response.data.errors) {
                    this.setValidateErrors(error.response.data.errors);
                }
            }).finally(() => {
                this.isLoading = false;
            });
        },
        clearData() {
            this.form = {
                id: 0,
                subject: '',
                email: '',
                body: ''
            };

            this.dialog = {
                show: false,
                width: '650px'
            };

            this.isSent = false;

            this.clearValidateErrors();
        },
        search() {
            this.options.page = 1;
            this.loadData();
        },
        close() {
            this.dialog.show = false;

            this.clearData();
        }
    }
}
</script>

<style lang="scss">
body.modal-open {
    overflow: hidden;
}

.popup-content {
    .ck-editor__editable_inline {
        min-height: 300px!important;
    }
}
</style>

<style scoped lang="scss">
.surname-research-section {

}

.surname-title {
    font-size: 1.5em;
    text-align: center;
}

.surname-table-wrap {
    margin-top: 30px;
    overflow-x: auto;
}

.action-icon {
    width: 25px!important;
    max-width: 25px!important;
    min-width: 25px!important;
    cursor: pointer;
}

.no-active {
    opacity: 0.3;
    cursor: inherit;
}

.surname-table {
    width: 100%;
    border-collapse: collapse;
    overflow-x: auto;

    thead {
        font-size: 0.8em;
        font-weight: bold;

        tr {
            th {
                padding: 0 15px;
            }
        }

        .surname {
            min-width: 150px;
            width: 100%;
        }

        .country {
            min-width: 150px;
            width: 100%;
        }

        .state {
            min-width: 200px;
            width: 100%;
        }

        .county {
            min-width: 175px;
            width: 100%;
        }

        .city {
            min-width: 175px;
            width: 100%;
        }

        .begin-year {
            min-width: 100px;
            width: 100%;
        }

        .end-year {
            min-width: 100px;
            width: 100%;
        }

        .udf,
        .alt-spelling {
            min-width: 150px;
            width: 100%;
        }

        .notes {
            min-width: 250px;
            width: 100%;
        }
    }

    tr {
        border-bottom: 1px solid #ccc;

        td {
            padding: 10px 15px;
        }
    }
}

.popup {
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 99999;
}

.popup-content {
    background-color: #fff;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 28px 20px 20px 20px;
    border-radius: 5px;
    overflow-y: auto;
    width: 100%;
    max-height: 90vh;

    input {
        border: 1px solid #ccced1;
        padding: 0 8px;
        height: 34px!important;
    }

    .error-messages {
        color: red;
        font-size: 0.8em;
        width: 100%;
    }

    button {
        background: #ffffff;
        min-width: 100px;
        border: 1px solid #000000;
        border-radius: 4px;
        height: 34px!important;
    }

    button.send {
        border-color: green;
        color: green;
    }

    button.send:focus, button.send:focus-visible {
        border-color: green!important;
    }

    button:hover {
        background: #f0f0f0;
    }

    .footer {
        padding: 16px 0 0 0;
        text-align: right;
    }

    .close {
        position: absolute;
        top: 20px;
        right: 20px;
        color: #aaa;
        font-size: 36px;
        font-weight: bold;
        line-height: 16px;
    }

    .close:hover,
    .close:focus {
        color: black;
        text-decoration: none;
        cursor: pointer;
    }
}
</style>
<style scoped lang="scss">
    .VuePagination__pagination li {
        list-style: none !important;
    }

    .paginate-wrapper {
        .page-link {
            cursor: pointer;
        }
    }

    .VuePagination {
        width: 100%;
        overflow-x: auto;
    }
</style>
